<template>
  <button
    v-if="!href"
    :type="type"
    :form="form"
    :style="styles"
    :name="name"
    :value="value"
    :disabled="disabled"
    class="def-button-primary"
    :class="{ 'def-button-primary_load': load, 'def-button-primary_big': big }"
  >
    <slot />
  </button>
  <a
    v-else
    :href="href"
    :style="styles"
    :target="target"
    class="def-button-primary"
    :class="{ 'def-button-primary_big': big }"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'DefButtonPrimary',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    href: {
      type: String,
    },
    form: String,
    styles: [String, Object],
    name: String,
    value: String,
    disabled: Boolean,
    load: Boolean,
    target: {
      type: String,
      default: '_self',
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.def-button-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  background-color: var(--background-black, #030304);
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  transition: 0.2s linear background-color;
  padding: 0 15px;
  white-space: nowrap;
  &:hover {
    background-color: var(--main-button-hover, #23232f);
  }
  &:disabled,
  &.disabled {
    cursor: not-allowed;
    color: #b0b0b0;
    background-color: #ededed;
  }
  &_big {
    @include point-md {
      height: 52px;
    }
  }
  &_load {
    /* меняем внешний вид курсора */
    cursor: progress;
    /* делаем кнопку полупрозрачной */
    opacity: 0.25;
    pointer-events: none;
  }
}
</style>
